import { useConsumerStatusSummaryQuery } from 'apollo/queries/autogenerate/hooks';
import { isPlusUser } from 'utils/user-types';

export default function useIsPlusUser() {
  const { data: consumerStatusSummary } = useConsumerStatusSummaryQuery();
  const hokatsuStatus = consumerStatusSummary?.houkatsuStatus.status;
  const kycStatus = consumerStatusSummary?.KYCApplicationStatus.status;

  return isPlusUser(kycStatus, hokatsuStatus);
}
